// 환경 설정
const config = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  hostname: window.location.hostname,
  location: window.location.href
};

console.log('🌐 환경 정보:', config);

// API URL 설정
export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://bll-pro-api.vercel.app'
  : 'http://localhost:3001';

// Supabase 설정
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Notion 설정
export const NOTION_TOKEN = process.env.REACT_APP_NOTION_TOKEN;
export const NOTION_DATABASE_ID = process.env.REACT_APP_NOTION_DATABASE_ID;

// Notion 토큰 가져오기
export const getNotionToken = () => {
  console.log('🔍 환경 변수 확인:', {
    NOTION_TOKEN: process.env.REACT_APP_NOTION_TOKEN,
    DATABASE_ID: process.env.REACT_APP_NOTION_DATABASE_ID,
    ALL_ENV: process.env
  });

  const token = process.env.REACT_APP_NOTION_TOKEN;
  if (!token) {
    console.error('❌ Notion 토큰이 설정되지 않았습니다.');
    console.log('현재 환경 변수:', process.env);
    throw new Error('Notion 토큰이 설정되지 않았습니다.');
  }
  return token;
};

// 사이트 URL 설정
export const SITE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_API_URL_MAIN
  : 'http://localhost:3000';

// 리다이렉트 URL 설정
export const REDIRECT_URL = `${SITE_URL}/auth/callback`;

// 사이트 설정 내보내기
export const siteConfig = {
  siteUrl: SITE_URL,
  redirectUrl: REDIRECT_URL
};

console.log('🔌 Supabase API URL 설정:', SUPABASE_URL);
console.log('🔑 Notion 설정 확인:', {
  hasToken: !!NOTION_TOKEN,
  hasDatabaseId: !!NOTION_DATABASE_ID
}); 